import React from "react";

const AddressTextField = ({
  name,
  type,
  placeholder,
  className,
  onChange,
  onBlur,
  validation,
  validationMsg,
  onkeypress,
  value,
  maxlength,
  style,
  readonly,
  id,
  autoComplete
}) => {
  return (
    <>
      <input
        name={name}
        id={id}
        placeholder={placeholder}
        className={className}
        type={type}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onkeypress}
        ref={validation}
        defaultValue={value}
        maxLength={maxlength}
        style={style}
        readOnly={readonly}
        autoComplete={autoComplete}
      />
      {validationMsg && (
        <>
          <span className="address1_error error_msg">{validationMsg}</span>
        </>
      )}
    </>
  );
};
export default AddressTextField;
